// extracted by css-extract-rspack-plugin
export default {"nogap":"LoginModal-nogap_nOS"};